<template>
  <MainLayout>
    <Chapter
      v-for="(chapter, index) in chapters"
      v-bind:key="index"
      :content="chapter"
    />
  </MainLayout>
</template>

<script>
import 'normalize.css'
import { MainLayout } from './layouts'
import { Chapter } from './components'
import { api } from './services/api'
export default {
  name: 'app',
  components: {
    MainLayout,
    Chapter,
  },
  data() {
    return {
      chapters: []
    }
  },
  created() {
    api.get('/chapters').then(res => {
      this.chapters = res.data.chapters
    })
  }
}
</script>

<style>
@import url("https://use.typekit.net/edj1wfi.css");
html {font-size: 1em;}

body {
  background-color: white;
  color: #3c4148;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "proxima-nova",sans-serif;
  font-weight: 400;
  line-height: 1.45;
}

p {margin-bottom: 1.3em;}

h1, h2, h3, h4 {
  margin: 0;
  margin-bottom: 0.5em;
  font-weight: inherit;
  line-height: 1.2;
}

h1 {
  margin-top: 0;
  font-size: 2.074em;
}

h2 {font-size: 1.728em;}

h3 {font-size: 1.44em;}

h4 {font-size: 1.2em;}

small, .font_small {font-size: 0.833em;}
</style>



// WEBPACK FOOTER //
// src/App.vue